import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { reloadApp } from '../core/utils/reload-app';


@Component({
  selector: 'app-promo-video',
  templateUrl: './promo-video.component.html',
  styleUrls: ['./promo-video.component.css']
})

export class PromoVideoComponent implements OnInit {
  @ViewChild('videoPlayer') videoPlayer: any;
  currentTime: any;
  showSkipButton: boolean = false;
  timer:any = 10;
  constructor(private router: Router,public dialogRef: MatDialogRef<PromoVideoComponent>) { 
  }
  
  ngOnInit(): void {
    this.videoPlayer = <HTMLVideoElement> document.createElement("videoPlayer");

  }

  reload(): void{
    reloadApp('manual_reload', { force: true });
  }

  closeDialog(): void {
    this.dialogRef.close();
    //this.router.navigate(['/gallery/' + localStorage.getItem('eventid')]);
    this.router.navigate(['/upload-selfie']);
  }


  onTimeUpdate(): void {
    this.currentTime = Math.round(this.videoPlayer.nativeElement.currentTime);
    // console.log(this.currentTime); //__CONSOLE_LOG__
    this.timer = Math.round(10-this.currentTime);
    if (this.currentTime > 10) {
      this.showSkipButton = true;
    }
  }

  skipVideo(): void {
    this.closeDialog();
  }

}
